import React from 'react';

interface AccessDeniedProps {
  /**
   * Custom message to display
   * @default "You don't have permission to access this page. Please contact your administrator to request access."
   */
  message?: string;
  /**
   * Custom title
   * @default "Access Restricted"
   */
  title?: string;
}

/**
 * Reusable component to display when user doesn't have permission to access a page/feature
 * 
 * @example
 * <AccessDenied />
 * 
 * @example
 * <AccessDenied 
 *   title="No Access"
 *   message="You need viewReports permission to view this page."
 * />
 */
export const AccessDenied: React.FC<AccessDeniedProps> = ({
  message = "You don't have permission to access this page. Please contact your administrator to request access.",
  title = "Access Restricted",
}) => {
  return (
    <div className="min-h-screen bg-background w-full px-4 sm:px-6 lg:px-8 flex items-center justify-center">
      <div className="text-center p-8 bg-white rounded-lg shadow-sm max-w-md">
        <svg
          className="w-16 h-16 mx-auto mb-4 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
          />
        </svg>
        <h3 className="text-xl font-bold text-text-primary mb-2">
          {title}
        </h3>
        <p className="text-text-secondary">
          {message}
        </p>
      </div>
    </div>
  );
};
